module.exports = __webpack_public_path__ + "static/img/nav_menu.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/nav_menu.png
// module id = 51
// module chunks = 0